import Vue from 'vue';
import '../scss/styles.scss';
import { IngredientTerm } from '../models/IngredientTerm';

export default Vue.extend({
  props: {
    items: {
      type: Array as () => IngredientTerm[],
      required: true,
    },
    getInitialIngredients: {
        type: Array as () => IngredientTerm[],
        required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    toggleClass(item: any) {
      // eslint-disable-next-line no-param-reassign
      item.Selected = !item.Selected;
      this.$emit('dataItemClicked', item);
    },
  },
  computed: {
    ingredientItems() {
      const newIng = this.getInitialIngredients;
      return newIng;
    },
  },
});
